// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__3T4db","footer":"ModalError_footer__3KIJJ"};